import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Loader } from "../components/Loader";
import { PageHeader } from "../components/PageHeader";
import { MapPin, Phone, Bike, CheckCircle2 } from "lucide-react";

const STEPS = [
  ["accepted", "قبل السائق الطلب"],
  ["at_store", "السائق في طريقه للمتجر"],
  ["picked_up", "تم استلام الشحنة"],
  ["at_customer", "السائق قريب منك"],
  ["delivered", "تم التسليم"],
];

export default function Track() {
  const { orderId } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);

  const load = async () => {
    try {
      const mine = await api("/orders/mine");
      setOrder(mine.find((o) => o.order_id === orderId) || null);
    } catch { setOrder(null); }
  };
  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, [orderId]); // eslint-disable-line

  if (order === null) return <Loader />;
  const curIdx = STEPS.findIndex(([k]) => k === order.delivery_status);

  return (
    <div className="animate-fade-in-up max-w-lg mx-auto">
      <PageHeader title="تتبّع الطلب" subtitle={order.product_name} />
      {order.assigned_driver_name && (
        <div className="flex items-center gap-3 p-4 bg-white rounded-2xl border border-[#E8EAF2] mb-4">
          <div className="w-12 h-12 rounded-2xl bg-[#3F8CFF] text-white flex items-center justify-center"><Bike size={22} /></div>
          <div className="flex-1"><p className="font-black text-[#161629]">{order.assigned_driver_name}</p><p className="text-xs text-[#6B7280]">السائق المكلّف</p></div>
          {order.delivery_phone && <a href={`tel:${order.delivery_phone}`} className="w-10 h-10 rounded-xl bg-[#00D26A] text-white flex items-center justify-center"><Phone size={18} /></a>}
        </div>
      )}
      <div className="p-4 bg-[#FFF7E0] border border-[#FFB627] rounded-2xl text-[#B07700] text-sm font-bold mb-4 flex items-center gap-2"><MapPin size={16} /> الخريطة الحيّة متاحة على تطبيق الجوال. هنا تُعرض حالة التوصيل لحظيًا.</div>
      <div className="bg-white rounded-2xl border border-[#E8EAF2] p-4">
        {STEPS.map(([k, label], i) => {
          const done = curIdx >= 0 && i <= curIdx;
          return (
            <div key={k} className="flex items-center gap-3 py-2.5">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${done ? "bg-[#00D26A] text-white" : "bg-[#F0F2FA] text-[#9CA3AF]"}`}>{done ? <CheckCircle2 size={18} /> : i + 1}</div>
              <span className={`font-bold ${done ? "text-[#161629]" : "text-[#9CA3AF]"}`}>{label}</span>
            </div>
          );
        })}
      </div>
      <button onClick={() => navigate("/orders")} className="w-full h-12 rounded-2xl bg-[#F0F2FA] text-[#161629] font-black mt-4">العودة للطلبات</button>
    </div>
  );
}
